<template>
  <b-card>
    <loading-container v-if="underlying.loading" />
    <error-display v-else-if="underlying.error" />
    <div v-else>
      <h1 class="mb-2">
        {{ underlying.data.name || 'Underlying' }}
      </h1>
      <b-row>
        <b-col
          v-for="(item, index) in displaySections"
          :key="index"
          cols="3"
          class="mb-2"
        >
          <h4 class="mb-0 text-muted">
            {{ item.section }}
          </h4>
          <h6
            v-if="isLink(item.entry)"
            class="mb-0"
          >
            <a
              :href="item.entry"
              target="_blank"
            >
              {{ getLinkText(item.section) }}
              <feather-icon
                icon="ExternalLinkIcon"
                size="14"
                class="ml-25"
                style="margin-bottom: 2px;"
              />
            </a>
          </h6>
          <h6
            v-else
            class="mb-0"
          >
            {{ item.entry || '-' }}
          </h6>
        </b-col>
        <b-col
          v-if="displaySections.length === 0"
          cols="12"
        >
          <h4 class="mb-0 text-muted">
            No Information Available
          </h4>
        </b-col>
      </b-row>
    </div>
  </b-card>
</template>

<script>
import {
  BCard, BRow, BCol,
} from 'bootstrap-vue'
import LoadingContainer from '@/views/components/LoadingContainer.vue'
import ErrorDisplay from '@/views/components/ErrorDisplay.vue'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    LoadingContainer,
    ErrorDisplay,
  },
  props: {
    underlying: {
      type: Object,
      required: true,
    },
  },
  computed: {
    displaySections() {
      if (!this.underlying.data.sections) return []

      // Filter out Name (shown in h1)
      return this.underlying.data.sections.filter(item => item.section !== 'Name')
    },
  },
  methods: {
    isLink(entry) {
      return entry && (entry.startsWith('http://') || entry.startsWith('https://'))
    },
    getLinkText(section) {
      // Generate friendly link text based on section name
      return `View ${section}`
    },
  },
}
</script>
